export default __webpack_public_path__ + "static/media/edit_white.e312f501.svg";